import type { ValueOf } from '@travel-planner/shared/types';

// The operations sub-tab identifiers. Lives in `shared/model` (the lowest
// layer) so both the `operations-layout` widget and the
// `operations-filters` feature's URL validator can import it without an
// upward (feature -> widget) layer crossing. Re-exported from the widget
// barrel for existing consumers.
export const OPERATIONS_TAB = {
  Home: 'home',
  Guides: 'guides',
  Tickets: 'tickets',
  Transport: 'transport',
  Messages: 'messages',
} as const;

export type OperationsTab = ValueOf<typeof OPERATIONS_TAB>;
